export function whenLayoutSettled(
  callback,
  { documentRef = document, windowRef = window } = {},
) {
  const run = () => {
    windowRef.requestAnimationFrame(() => {
      windowRef.requestAnimationFrame(callback);
    });
  };

  if (documentRef.readyState === "complete") {
    run();
  } else {
    windowRef.addEventListener("load", run, { once: true });
  }
}
